import { BellRingingIcon } from "@phosphor-icons/react";
import { cn } from "@reactive-resume/utils";

import { NotificationSettings as ExistingNotificationSettings } from "../../../dashboard/settings/_sections/notification-settings";

export const UserNotificationSettings = () => {
  return (
    <section
      className={cn(
        "rounded-2xl border border-slate-200 bg-white",
        "p-4 shadow-[0_10px_35px_rgba(15,23,42,0.05)]",
        "sm:p-6 lg:p-7",
      )}
    >
      <div className="mb-5 flex items-start gap-3 border-b border-slate-200 pb-5">
        <span className="grid size-10 shrink-0 place-items-center rounded-xl bg-emerald-50 text-emerald-600">
          <BellRingingIcon aria-hidden size={21} weight="duotone" />
        </span>

        <div>
          <h2 className="text-base font-bold text-indigo-950">Préférences de notifications</h2>

          <p className="mt-1 text-xs leading-5 text-slate-500">
            Définissez les informations que vous souhaitez recevoir et les canaux autorisés.
          </p>
        </div>
      </div>

      <ExistingNotificationSettings />
    </section>
  );
};
